<template>
  <section>
    <section v-show="!reporteActual">
      <v-form @submit.prevent="obtenerReportes">
        <v-layout row>
          <v-flex xs12 md3>
            <v-text-field
              clearable
              v-model="filtros.NombreReporte"
              light
              outlined
              label="Buscar Reporte"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md1>
            <v-btn fab type="submit" color="primary" dark
              ><v-icon dark color="white">search</v-icon></v-btn
            >
          </v-flex>
        </v-layout>
      </v-form>
      <v-card>
        <v-card-text>
          <v-simple-table fixed-header height="660px">
            <template v-slot:default>
              <thead>
                <tr>
                  <th width="100" class="text-left primary--text">
                    Código
                  </th>
                  <th class="text-left primary--text">
                    Reporte
                  </th>
                  <th width="100"></th>
                </tr>
              </thead>
              <tbody v-if="!reportes.length">
                <td colspan="2">
                  <div class="ma-3">
                    No se encontraron reportes
                  </div>
                </td>
              </tbody>

              <tbody>
                <template v-for="reporte in reportes">
                  <tr
                    @click.prevent="ejecutarReporte(reporte)"
                    :key="reporte.CatalogoReporteID"
                    class="link"
                  >
                    <td>
                      {{ reporte.CatalogoReporteID }}
                    </td>
                    <td>
                      {{ reporte.NombreReporte }}
                    </td>
                    <td class="text-right">
                      <v-icon>chevron_right</v-icon>
                    </td>
                  </tr>
                </template>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </section>
    <reporte-dinamico
      @cerrar="cerrarReporte"
      v-if="!!reporteActual"
      :catalogoReporte="reporteActual"
    ></reporte-dinamico>
  </section>
</template>

<script>
import ServicioReportes from '../../services/reportes';
import ReporteDinamico from './ReporteDinamico.vue';
export default {
  components: {ReporteDinamico},
  name: 'reportes',
  data() {
    return {
      filtros: {
        NombreReporte: '',
      },
      reportes: [],
      reporteActual: null,
    };
  },
  methods: {
    cerrarReporte() {
      this.reporteActual = null;
    },
    ejecutarReporte(reporte) {
      this.reporteActual = reporte;
    },
    async obtenerReportes() {
      const res = await ServicioReportes.obtenerReportes(this.filtros);
      if (res.data.result === 1) {
        this.reportes = res.data.data.Table0;
      } else {
        this.$root.mensajeError = res.data.message;
      }
    },
  },
  mounted() {
    this.obtenerReportes();
  },
};
</script>

<style></style>
